import keyMirror from 'keymirror'
import type { ComposerSaveButton } from './stores/types'

export { AttachmentTypes, Services } from '~publish/legacy/constants'

export { NotificationTypes, NotificationScopes } from './values/Notification'

export const LinkAttachmentTextFieldTypes = keyMirror({
  TITLE: null,
  DESCRIPTION: null,
})

export const ErrorTypes = keyMirror({
  INLINE: null,
  FLOATING: null,
})

export const FloatingErrorCodes = [
  401, 403, 404, 405, 429, 1000, 1001, 1002, 1003, 1005, 1006, 1007, 1042, 1050,
  1051,
]

export const UpgradeErrorCodes = {
  queueLimit: 1023, // Reached profile queue limit
}

export const ComposerInitiators = {
  ImageBufferButtons: ['hover_button_image', 'menu-image'],
}

export const QueueingTypes = {
  NEXT: 'NEXT',
  QUEUE: 'QUEUE',
  NOW: 'NOW',
  CUSTOM: 'CUSTOM',
  SAVE: 'SAVE',
  ADD_DRAFT: 'ADD_DRAFT',
  NEXT_DRAFT: 'NEXT_DRAFT',
  CUSTOM_DRAFT: 'CUSTOM_DRAFT',
} as const

export const SaveButtonTypes = {
  ADD_TO_QUEUE: 'ADD_TO_QUEUE',
  SHARE_NEXT: 'SHARE_NEXT',
  SHARE_NOW: 'SHARE_NOW',
  SCHEDULE_POST: 'SCHEDULE_POST',
  SAVE: 'SAVE',
  ADD_TO_DRAFTS: 'ADD_TO_DRAFTS',
  SCHEDULE_DRAFT: 'SCHEDULE_DRAFT',
  ADD_TO_DRAFTS_REQUESTING_APPROVAL: 'ADD_TO_DRAFTS_REQUESTING_APPROVAL',
} as const

export const PaywallButtonTypes = {
  REQUEST_APPROVAL_PAYWALL: 'REQUEST_APPROVAL_PAYWALL',
} as const

export const InlineSaveButtonTypes: ComposerSaveButton[] = [
  SaveButtonTypes.SAVE,
]

export const ButtonsQueuingTypesMap = new Map([
  [SaveButtonTypes.ADD_TO_QUEUE, QueueingTypes.QUEUE],
  [SaveButtonTypes.SHARE_NEXT, QueueingTypes.NEXT],
  [SaveButtonTypes.SHARE_NOW, QueueingTypes.NOW],
  [SaveButtonTypes.SCHEDULE_POST, QueueingTypes.CUSTOM],
  [SaveButtonTypes.SAVE, QueueingTypes.SAVE],
  [SaveButtonTypes.ADD_TO_DRAFTS, QueueingTypes.ADD_DRAFT],
  [SaveButtonTypes.SCHEDULE_DRAFT, QueueingTypes.CUSTOM_DRAFT],
  [SaveButtonTypes.ADD_TO_DRAFTS_REQUESTING_APPROVAL, QueueingTypes.ADD_DRAFT],
])

export const AsyncOperationStates = keyMirror({
  PENDING: null,
  DONE: null,
})

export const MediaUploadConfig = {
  endpoint: '/upload/media',
}

export const bufferOriginRegex = /https?:\/\/(?:[^.]+\.)?buffer(?:app)?\.com/
export const bufferOrigins = new Map([
  ['local', 'https://local.buffer.com'],
  [
    'production',
    bufferOriginRegex.test(window.location.origin)
      ? window.location.origin
      : 'https://buffer.com',
  ],
])

export const InstagramAspectRatioLimits = {
  min: 0.8,
  max: 1.91,
}

export const InstagramThumbnailMaxSize = 500

export const COMPOSER_ERROR_CODE = {
  MISSING_PROFILE: 'MISSING_PROFILE',
  PROCESSING: 'PROCESSING',
  ALREADY_SAVED: 'ALREADY_SAVED',
  SCHEDULE_IN_THE_PAST: 'SCHEDULE_IN_THE_PAST',
  NOT_ENABLED: 'NOT_ENABLED',
  NO_PERMISSION: 'NO_PERMISSION',
} as const
